import oauth from './oauth.es6';
export default {
	getDomInDetails(){
		let authEnv;
		let host;
		if (typeof window !== 'undefined') {
			host = window.location.host.toLowerCase();
			authEnv = '';
			if (host.indexOf('.devint') > 0 || host.indexOf('.feature') > 0 || host.indexOf('.qa') > 0 || host.indexOf('localhost') >= 0) {
				authEnv = '.staging';
			} else if (host.indexOf('.preview') > 0) {
				authEnv = '.qa00';
			} else if (host.indexOf('.staging') > 0) {
				authEnv = '.staging';
			}
		}
		return {
			authEnv,
		};
	},
	getHeaders(options) {
		const self = this;
		const env = this.getDomInDetails().authEnv;
		return new Promise((resolve) => {
			resolve(self.getHeaderObjectFromOAuthObject(oauth.generate(options, env)));
		});
	},
	getHeaderObjectFromOAuthObject(OAuthObject) {
		return {
			headers: {
				Accept: 'application/json',
				enc_data: OAuthObject.enc_data,
				client_id: OAuthObject.client_id,
				timestamp: OAuthObject.timestamp
			},
		};
	},
	getUserHeaders(options, authToken) {
		const self = this;
		const env = this.getDomInDetails().authEnv;
		return new Promise((resolve) => {
			resolve(self.getUserHeaderObjectFromOAuthObject(oauth.generate(options, env), authToken));
		});
	},
	getTokenHeaders(options) {
		const self = this;
		const env = this.getDomInDetails().authEnv;
		return new Promise((resolve) => {
			resolve(self.getUserTokenHeaderObjectFromOAuthObject(oauth.generate(options, env)));
		});
	},
	getUserTokenHeaderObjectFromOAuthObject(OAuthObject) {
		return {
			headers: {
				client_id: OAuthObject.client_id,
				client_secret: OAuthObject.client_secret,
			},
		};
	},
	getUserHeaderObjectFromOAuthObject(OAuthObject, token) {
		return {
			headers: {
				Accept: 'application/json',
				enc_data: OAuthObject.enc_data,
				client_id: OAuthObject.client_id,
				timestamp: OAuthObject.timestamp,
				Authorization: `Bearer ${token}`,
			},
		};
	},
};
